import { render } from "./WinsHeatmap.vue?vue&type=template&id=2de637f7"
import script from "./WinsHeatmap.vue?vue&type=script&lang=js"
export * from "./WinsHeatmap.vue?vue&type=script&lang=js"

import "./WinsHeatmap.vue?vue&type=style&index=0&id=2de637f7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__